<template>
  <div class="head">
    <div class="lockming-head">
      <div class="lockming-head-box">
        <p style="font-size: 24px;font-weight: 600;margin-bottom: 8px;">{{ $t('other.allrevenue') }} : </p>
        <span style="font-size: 20px;">{{ parseFloat(infos.total_revenue).toFixed(2) }}</span>
        <van-row style="margin: 20px 0 0;line-height: 2.5;">
          <van-col :span="8">{{ $t('other.stakingcount') }}</van-col>
          <van-col :span="8">{{ $t('other.stakingamount') }}</van-col>
          <van-col :span="8">{{ $t('other.todayincome') }}</van-col>
          <van-col :span="8">{{ parseFloat(infos.staking_count) }}</van-col>
          <van-col :span="8">{{ parseFloat(infos.staking_amount).toFixed(2) }}</van-col>
          <van-col :span="8">{{ parseFloat(infos.total_revenue).toFixed(2) }}</van-col>
        </van-row>
      </div>
    </div>
    <van-tabs v-model="active">
      <van-tab :title="$t('lockming.order_tab')" />
      <van-tab :title="$t('lockming.pro_tab')" />
    </van-tabs>
    <div class="head-tab-page-overflow" style="height: calc(100vh - 310px);">
      <div v-if="active == 0">
        <div class="data-box" v-if="list.length > 0">
          <van-pull-refresh
            :pulling-text="$t('common.pulling')"
            :loosing-text="$t('common.loosing')"
            :loading-text="$t('common.loading')"
            v-model="refreshing"
            @refresh="onRefresh"
          >
            <van-list
              v-model="loading"
              :finished="finished"
              :finished-text="$t('common.nomore')"
              :loading-text="$t('common.loading')"
              :error-text="$t('common.errortxt')"
              @load="onLoad"
            >
              <LockmingOrder
                v-for="(item, index) in list"
                :item="item"
                :key="index"
                @reset-data="ResetData"
              />
            </van-list>
          </van-pull-refresh>
        </div>
        <div v-else class="data-box">
          <van-empty :description="$t('common.nodata')" />
        </div>
      </div>
      <div v-if="active == 1">
        <div v-if="datas && datas.length > 0">
          <LockmingPro
            v-for="(item, index) in datas"
            :item="item"
            :key="index"
          />
        </div>
        <div v-else>
          <van-empty :description="$t('common.nodata')" />
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Footer from '@/components/Footer'
import { LockmingPro, LockmingOrder } from './components/index'
export default {
  name: 'LockmingView',
  components: { Footer, LockmingPro, LockmingOrder },
  data () {
    return {
      active: 1,
      datas: [],
      infos:{},
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
      page: 1,
      limit: 10
    }
  },
  watch: {
    active (newVal) {
      if (newVal == 1) {
        this.getDataPro()
      } else {
        this.onRefresh()
      }
    }
  },
  mounted () {
    this.getDataPro()
    this.getUserStakingInf()
  },
  methods: {
    ResetData () {
      this.onRefresh()
    },
    onConfirm (val) {
      this.statuslabel = val.label
      this.statusval = val.value
      this.show = false
      this.onRefresh()
    },
    async getUserStakingInf(){
      
      await this.$http({
        method: 'post',
        url: 'getUserStakingInfo'
      }).then(res => {
        this.infos = res.data
      })
    },
    async getDataPro () {
      await this.$http({
        method: 'post',
        url: 'getMiningMachineList'
      }).then(res => {
        this.datas = res.data.list
      })
    },
    onLoad () {
      this.getData()
    },
    async getData () {
      await this.$http({
        method: 'post',
        url: 'getMiningMachineOrders',
        data: {
          page: this.page,
          limit: this.limit
        }
      }).then(res => {
        this.refreshing = false
        this.loading = false
        if (res && res.data && res.data.list) {
          res.data.list.forEach(element => {
            this.list.push(element)
          })
          if (res.data.list.length < this.limit) {
            this.finished = true
          } else {
            this.page += 1
            this.finished = false
          }
        } else {
          this.finished = true
        }
      })
    },
    onRefresh () {
      this.page = 1
      this.list = []
      // 清空列表数据
      this.finished = false
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true
      this.onLoad()
    }
  }
}
</script>
<style scoped>
.lockming-head {
  padding: 200px 20px 0px;
  background: url(../../assets/img_3.jpg);
  background-repeat: no-repeat;
  background-size: 100%;
  line-height: 2;
  color: #fff;
}
.lockming-head-box {
  display: none;
  border-radius: 10px;
  padding: 10px 20px;
  line-height: 1.5;
  border: 1px solid rgb(12, 40, 68);
  background: rgb(39, 76, 114,0.9);
  box-shadow: rgb(6, 23, 35) 0px 0px 15px 0px;
  width: 90%;
  margin: 10px auto;
}
</style>
